import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import merge from 'lodash/merge';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';

var stripHTML = function stripHTML(html) {
  return html ? html.replace(/<a href="#fn.*?rel="footnote">.*?<\/a>/gi, '').replace(/<div class="footnotes"><ol>.*?<\/ol><\/div>/, '').replace(/(<\/p>|<br>)/gi, ' ').replace(/<\/?[^>]+>/gi, '').replace(/(\r\n|\n|\r)+/gm, ' ').trim() : "";
};
/* Used by GhostArticle to render relevant meta tags and AMP data for SEO purposes */


var ArticleMetaTags = function ArticleMetaTags(_ref) {
  var article = _ref.article,
      domain = _ref.domain,
      ampArticleData = _ref.ampArticleData,
      metadata = _ref.metadata;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var plaintextDescription = stripHTML(article.html).split(' ').splice(0, 50).join(' ');
  var richArticleData = merge(ampArticleData, {
    '@context': 'https://schema.org',
    '@type': 'Article',
    author: {
      '@type': 'Person',
      name: article.primary_author.name,
      sameAs: []
    },
    headline: article.title,
    url: "" + domain + pathname,
    datePublished: article.published_at,
    dateModified: article.updated_at,
    description: article.meta_description || article.og_description || article.custom_excerpt || article.meta_description || plaintextDescription,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': domain
    }
  }); // Filter all null / undefined values from the metadata and provide all
  // default values that are possible

  var cleanMetadata = pickBy(merge({
    description: article.meta_description || article.og_description || article.custom_excerpt || plaintextDescription,
    'og:type': "article",
    'og:title': article.og_title || article.meta_title || article.title,
    'og:description': article.og_description || article.custom_excerpt || article.meta_description || plaintextDescription,
    'og:image': article.feature_image,
    'og:url': "" + domain + pathname,
    'article:published_time': article.published_at,
    'article:modified_time': article.updated_at,
    'article:author': article.primary_author.facebook,
    'twitter:title': article.twitter_title || article.meta_title || article.title,
    'twitter:description': article.twitter_description || article.custom_excerpt || article.meta_description || plaintextDescription,
    'twitter:url': "" + domain + pathname,
    'twitter:image': article.feature_image,
    'twitter:creator': article.primary_author.twitter
  }, metadata), identity);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, article.meta_title || article.title || 'Article'), /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: "" + domain + pathname
  }), Object.entries(cleanMetadata).map(function (keyValue) {
    return /*#__PURE__*/React.createElement("meta", {
      name: keyValue[0],
      property: keyValue[0],
      content: keyValue[1],
      key: keyValue[0]
    });
  }), /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(richArticleData)));
};

ArticleMetaTags.propTypes = {
  article: PropTypes.object.isRequired,
  domain: PropTypes.string.isRequired,
  metadata: PropTypes.object,
  ampArticleData: PropTypes.object
};
ArticleMetaTags.defaultProps = {
  metadata: {},
  ampArticleData: {}
};
export default ArticleMetaTags;